import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'Components';
import './ImageContainer.css';

const NoImage = () => (<div className="image-container__no-img" ><p><Icon icon="photo" />No image available</p></div>);

const ImageContainer = ({
  src,
  alt,
  fallbackImage,
  ...rest
}) => (
  <div className="image-container">
    {src !== '' ?
      <img
        src={src}
        alt={alt}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = fallbackImage;
        }}
        {...rest}
      />
        :
      <NoImage />
    }
  </div>
);

ImageContainer.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  fallbackImage: PropTypes.string,
};

ImageContainer.defaultProps = {
  src: '',
  alt: '',
  fallbackImage: '',
};

export default ImageContainer;



// WEBPACK FOOTER //
// ./src/components/ImageContainer/ImageContainer.jsx